import type { OnDestroy, OnInit } from '@angular/core';
import { Directive, TemplateRef, inject } from '@angular/core';
import { Sidebar } from './sidebar.service';

@Directive({ standalone: true, selector: '[flSidebarCustom]' })
export class SidebarCustomTemplateDirective implements OnInit, OnDestroy {
  private templateRef = inject<TemplateRef<any>>(TemplateRef);
  private sidebar = inject(Sidebar);

  ngOnInit(): void {
    this.sidebar.setCustomTemplate(this.templateRef);
  }

  ngOnDestroy(): void {
    this.sidebar.setCustomTemplate(undefined);
  }
}
